var map = {
	"./icon-alternatives.svg": 760,
	"./icon-download.svg": 5657,
	"./icon-flag-de.svg": 7025,
	"./icon-flag-dk.svg": 7791,
	"./icon-flag-no.svg": 158,
	"./icon-flag-se.svg": 8740,
	"./icon-flag-uk.svg": 4395,
	"./icon-light-green.svg": 7786,
	"./icon-light-red.svg": 4903,
	"./icon-light-yellow.svg": 1605,
	"./icon-link.svg": 8693,
	"./icon-maintenance.svg": 2023,
	"./icon-multiple.svg": 2423,
	"./icon-production.svg": 1073,
	"./icon-recommended-items.svg": 6799,
	"./icon-replaced.svg": 4159,
	"./icon-tree-leaf.svg": 3612,
	"./icon-tree-node.svg": 7522,
	"./icon-where-used.svg": 4039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6541;